var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpForMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.663 7.52772C12.663 7.67391 12.663 7.75807 12.663 7.84667C12.663 11.1646 12.663 14.478 12.663 17.7959C12.663 18.2079 12.4982 18.4117 12.112 18.487C11.731 18.5578 11.3551 18.3319 11.3139 17.9997C11.3036 17.9067 11.3036 17.8092 11.3036 17.7118C11.3036 14.4249 11.3036 11.138 11.3036 7.8511C11.3036 7.7625 11.3036 7.67391 11.3036 7.53215C11.2006 7.61189 11.1336 7.66062 11.0718 7.71377C9.95957 8.6706 8.85244 9.62743 7.73502 10.5754C7.61658 10.6773 7.4415 10.7659 7.27672 10.7925C6.97805 10.85 6.70513 10.7127 6.57125 10.4868C6.43736 10.2653 6.49401 9.97295 6.72573 9.77804C7.42605 9.17117 8.13152 8.56429 8.837 7.96184C9.6918 7.2265 10.5466 6.49116 11.4066 5.75582C11.8031 5.41473 12.1687 5.41473 12.5652 5.75582C14.1255 7.09804 15.6857 8.43583 17.246 9.78247C17.5292 10.0261 17.5704 10.2786 17.3953 10.5444C17.2409 10.7703 16.9216 10.8899 16.6178 10.8013C16.4788 10.7615 16.3449 10.6773 16.2367 10.5843C15.1193 9.63186 14.0122 8.67503 12.8999 7.72263C12.8381 7.66505 12.7712 7.61632 12.663 7.52772Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpForMessage);
export default __webpack_public_path__ + "static/media/arrow-up-for-message.2a319c563eb4ab9b2d7203620b04d1bb.svg";
export { ForwardRef as ReactComponent };